import React from 'react';
import { Link } from 'react-router-dom';
import LoginForm from '../../components/LoginForm';
import FestifyLogo from '../../components/FestifyLogo';
import './styles.css';

function Login() {
  return (
    <div className="page-container login-page">
      <div className="card">
        <FestifyLogo subtitle="Convites elegantes para eventos memoráveis" />
        <h1 className="card-title">Entrar</h1>
        <LoginForm />
        <p className="toggle-text">
          <Link to="/esqueci-senha" className="toggle-btn forgot-password-link">Esqueci minha senha</Link>
        </p>
        <p className="toggle-text">
          Não tem conta? <Link to="/cadastro" className="toggle-btn">Cadastre-se</Link>
        </p>
      </div>
    </div>
  );
}

export default Login;
